// extracted by mini-css-extract-plugin
module.exports = {"topArray":"topArray_topArray__3zGjc","box":"topArray_box__13yWG","avg":"topArray_avg__1lkX5"};